import React, {useEffect, useState} from 'react';
import Loader from "../../Loader";
import {formatToPersianAddCommaNegativeToParentheses} from "../../../utils/CommaSeparator";
import numericFunction from "../../../utils/NumericFunction";

const CostAndBenefitPrint = (props) => {

  const [componentData, setComponentData] = useState({})
  const [columnField, setColumnField] = useState([])
  const format = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  useEffect(() => {
    const temp = {...props.data.data.mainData}
    setComponentData(temp)

    let flag = []
    props.data.data.mainData.column.forEach((v) => {
      flag.push(v.field)
    })
    setColumnField(flag)
  }, [props.data])

  try {
    return (
      <>
        {componentData.column.length > 0 ?
          <div className="main-print-factor">
            <div className="box-top-side-review-accounts">

              <div className="shop-name">
                <div className="name-side">
                  <h3>{componentData?.shopName}</h3>
                </div>
              </div>

              <div className="list-detail">
                <div className="inline-text">
                  <p>از تاریخ :</p>
                  <p>{numericFunction.e2p(componentData?.startDate)}</p>
                </div>

                <div className="inline-text">
                  <p>از سند :</p>
                  <p>{numericFunction.e2p(componentData?.firstId)}</p>
                </div>

                <div className="inline-text">
                  <p>تـاریـخ :</p>
                  <p>{new Date().toLocaleDateString("fa-ir", format)}</p>
                </div>

                <div className="inline-text">
                  <p>تا تاریخ :</p>
                  <p>{numericFunction.e2p(componentData?.endDate)}</p>
                </div>

                <div className="inline-text">
                  <p>تا سند :</p>
                  <p>{numericFunction.e2p(componentData?.lastId)}</p>
                </div>

                <div className="inline-text" style={{columnGap: '4px'}}>
                  {/*<p>شماره صفحه :</p>*/}
                  {/*<p>{numericFunction.e2p(index + 1)}</p>*/}
                  {/*<p>از</p>*/}
                  {/*<p>{numericFunction.e2p(makeData.length)}</p>*/}
                </div>
              </div>
            </div>

            <div className="main-cost-and-benefit-print">
              <table className="solid-print-table">
                <thead>
                <tr>
                  <th colSpan="5">{componentData.part_1.caption}</th>
                </tr>
                <tr>{componentData.column.map((v, index) =>
                  <th style={{width: v.field === "title" ? '60%' : "auto"}} key={index}>{v.title}</th>
                )}
                </tr>
                </thead>

                <tbody>
                {componentData.part_1.data.map((v) =>
                  <tr>
                    {columnField.map((q) =>
                      <th>{formatToPersianAddCommaNegativeToParentheses(v[q])}</th>
                    )}
                  </tr>
                )}
                </tbody>

                <tfoot>
                <tr>
                  <th>{"جمع " + " " + componentData?.part_1?.caption}</th>
                  <th>{formatToPersianAddCommaNegativeToParentheses(componentData?.part_1?.data?.reduce((sum, item) => sum + +item.totalRemaining, 0))}</th>
                </tr>
                </tfoot>
              </table>


              <table className="solid-print-table">
                <thead>
                <tr>
                  <th colSpan="5">{componentData.part_2.caption}</th>
                </tr>
                <tr>{componentData.column.map((v, index) =>
                  <th style={{width: v.field === "title" ? '60%' : "auto"}} key={index}>{v.title}</th>
                )}
                </tr>
                </thead>

                <tbody>
                {componentData.part_2.data.map((v) =>
                  <tr>
                    {columnField.map((q) =>
                      <th>{formatToPersianAddCommaNegativeToParentheses(v[q])}</th>
                    )}
                  </tr>
                )}
                </tbody>

                <tfoot>
                <tr>
                  <th>{"جمع " + " " + componentData?.part_2?.caption}</th>
                  <th>{formatToPersianAddCommaNegativeToParentheses(componentData?.part_2?.data?.reduce((sum, item) => sum + +item.totalRemaining, 0))}</th>
                </tr>
                </tfoot>
              </table>


              <table className="solid-print-table">
                <thead>
                <tr>
                  <th colSpan="5">{componentData.part_3.caption}</th>
                </tr>
                <tr>{componentData.column.map((v, index) =>
                  <th style={{width: v.field === "title" ? '60%' : "auto"}} key={index}>{v.title}</th>
                )}
                </tr>
                </thead>

                <tbody>
                {componentData.part_3.data.map((v) =>
                  <tr>
                    {columnField.map((q) =>
                      <th>{formatToPersianAddCommaNegativeToParentheses(v[q])}</th>
                    )}
                  </tr>
                )}
                </tbody>

                <tfoot>
                <tr>
                  <th>{"جمع " + " " + componentData?.part_3?.caption}</th>
                  <th>{formatToPersianAddCommaNegativeToParentheses(componentData?.part_3?.data?.reduce((sum, item) => sum + +item.totalRemaining, 0))}</th>
                </tr>
                </tfoot>
              </table>


              <table className="solid-print-table">
                <thead>
                <tr>
                  <th colSpan="5">{componentData.part_4.caption}</th>
                </tr>
                <tr>{componentData.column.map((v, index) =>
                  <th style={{width: v.field === "title" ? '60%' : "auto"}} key={index}>{v.title}</th>
                )}
                </tr>
                </thead>

                <tbody>
                {componentData.part_4.data.map((v) =>
                  <tr>
                    {columnField.map((q) =>
                      <th>{formatToPersianAddCommaNegativeToParentheses(v[q])}</th>
                    )}
                  </tr>
                )}
                </tbody>

                <tfoot>
                <tr>
                  <th>{"جمع " + " " + componentData?.part_4?.caption}</th>
                  <th>{formatToPersianAddCommaNegativeToParentheses(componentData?.part_4?.data?.reduce((sum, item) => sum + +item.totalRemaining, 0))}</th>
                </tr>
                </tfoot>
              </table>
            </div>

            <div className="bottom-page-sum">

            </div>
          </div> : <Loader/>
        }
      </>
    );
  } catch (error) {
    return <>{error.toLocaleString()}</>
  }
};

export default CostAndBenefitPrint;